import Offer, { OfferTourManageTableModel, OfferManageTourModel } from './Offer'
import { guid, Photo } from 'traveldesk-ui'
import BaseEntity from './BaseEntity'
import CancellationPolicy from './CancellationPolicy'
import { AccountSettingsModel } from './AccountSettingsModel'
import TourFaqModel from './TourFaqModel'
import ItineraryModel from './ItineraryModel'
import TourExternalLinkModel from './TourExternalLinkModel'

export class TourManageModel extends BaseEntity {
    public static Create(obj: TourManageModel, accountSettings: AccountSettingsModel) {
        const res = Object.assign(new TourManageModel(), obj, {
            offers: obj.offers.map((x) => OfferManageTourModel.Create(x, accountSettings)),
            directions: obj.directions.map(x => TourDirectionModel.Create(x)),
            itineraries: obj.itineraries.map(x => ItineraryModel.Create(x)),
            externalLinks: obj.externalLinks.map(x => TourExternalLinkModel.Create(x)),
            tourOverview: obj.tourOverview ? TourOverviewModel.Create(obj.tourOverview) : undefined
        })
        if (res.cityId === 0) res.cityId = undefined
        return res
    }
    id: number = 0
    nameInternal: string = ''
    nameDisplay: string = ''
    url: string = ''
    cityId?: number = 0
    toursCategories: number[] = []
    recommendedFor: number = 0
    languageId: number = 0
    isDeleted: boolean = false
    videoUrl: string = ''
    cancellationPolicy: CancellationPolicy[] = []
    externalLinks: TourExternalLinkModel[] = []
    // heroImage: Photo = new Photo()
    offers: OfferManageTourModel[] = []
    heroImageId?: number = undefined
    photos: Photo[] = []
    isDefaultCancellationPolicy: boolean = true
    isDefaultNotesToClientsPostBooking: boolean = true
    isDefaultTermsAndConditions: boolean = true
    isDefaultFaq: boolean = true
    termsAndConditions: string = ''
    faq: string = ''
    faqs: TourFaqModel[] = []
    shortDescription: string = ''
    salesDescription: string = ''
    tourItinerary: string = ''
    tourOverview: TourOverviewModel | undefined = undefined
    itineraries: ItineraryModel[] = []
    notesToAgents: string = ''
    seo: string = ''
    seoPageTitle: string = ''
    seoPageDescription: string = ''
    notesToClientsPostBooking: string = ''
    locationTiming: string = ''
    locationAddress: string = ''
    locationLatitude?: number
    locationLongitude?: number
    locationMapUrl?: string
    locationMapPhotoBase64: string = ''
    isDropLocationMap: boolean = false
    googlePlacesId?: string
    googlePlacesRating?: number
    googlePlacesTotalRatings?: number
    tripAdvisorId?: string
    tripAdvisorRating?: number
    tripAdvisorTotalRatings?: number
    facebookPageId?: string
    isTopTour: boolean = false
    directions: TourDirectionModel[] = []
    updateDirection = (type: DirectionType, value: string) => {

    }
}
export class TourOverviewModel {
    public static Create(obj: TourOverviewModel) {
        return Object.assign(new TourOverviewModel(), obj, {
            points: obj.points || []
        })
    }
    id: number = 0
    tourId: number = 0
    title: string = ''
    description: string = ''
    heroImageId?: number = undefined
    heroImage?: Photo = undefined
    points: TourOverviewPointModel[] = []
    get hasError() {
        return !this.title && !this.heroImageId && !this.description
            ? "Tour overview should have image title or description"
            : this.points.some(p => p.hasError)
                ? "All key points should have at least icon, title or description"
                : ''
    }
}
export class TourOverviewPointModel {

    id: number = 0
    guid: string = guid()
    title: string = ''
    description: string = ''
    iconType: TourOverViewIconType = TourOverViewIconType.Na
    get hasError() {
        return !this.iconType && !this.description && !this.title ? "Key point should have at least icon, title or descrption" : ""
    }
}
export enum TourOverViewIconType {
    Na, Reserve, Time, Calendar, Message
}
export const TourOverViewIconTypeOptions = [
    { label: "N/A", value: TourOverViewIconType.Na },
    { label: "Reserve", value: TourOverViewIconType.Reserve },
    { label: "Time", value: TourOverViewIconType.Time },
    { label: "Calendar", value: TourOverViewIconType.Calendar },
    { label: "Message", value: TourOverViewIconType.Message },
]
export class TourDirectionModel {
    public static Create(obj: TourDirectionModel) {
        return Object.assign(new TourDirectionModel(), obj)
    }
    tourId: number = 0
    type: DirectionType = DirectionType.ByBus
    description: string = ''

}
export enum DirectionType {
    ByCar, ByBus, ByMetro
}
export const DirectionTypesOptions = [
    { value: DirectionType.ByCar, label: "By Car" },
    { value: DirectionType.ByBus, label: "By Bus" },
    { value: DirectionType.ByMetro, label: "By Metro" }
]
export class TourManageTableModel extends BaseEntity {
    public static Create(obj: TourManageTableModel) {
        return Object.assign(new TourManageTableModel(), obj)
    }
    nameDisplay: string = ''
    nameInternal: string = ''
    languageId: number = 0
    offers: OfferTourManageTableModel[] = []
    isTopTour: boolean = false
}
